import React from "react";
import { NavItem } from "react-bootstrap";
import Nav from 'react-bootstrap/Nav';

const CategoryNav = () => {
  return (
    <section className="categoryNav">
        <div className="container">
            <Nav className="justify-content-start" activeKey={"All"}>
                <Nav.Item >
                    <Nav.Link eventKey={"All"}>
                        All Products
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item >
                    <Nav.Link eventKey={"category_1"}>
                        Category 1
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item >
                    <Nav.Link eventKey={"category_2"}>
                        Category 2
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item >
                    <Nav.Link eventKey={"category_3"}>
                        Category 3
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item >
                    <Nav.Link eventKey={"category_4"}>
                        Category 4
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item >
                    <Nav.Link eventKey={"category_5"}>
                        Category 5
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item >
                    <Nav.Link eventKey={"Other"}>
                        Other
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        </div>
    </section>
  );
};

export default CategoryNav;